/* 米德接口 */
import config from './config';
import work from './work';
import wxMenuHide from './wxMenuHide';
import getWXSign from './getWXSign';

export default {
    config,
    work,
    wxMenuHide,
    getWXSign
};
